import React from "react";

import Text from "../Typography/Text";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TitleBlock.module.css";

interface Props {
  title: string;
  subTitle?: string;
  className?: string;
  titleVariant?: "title1" | "title2" | "title3";
  subtitleVariant?: "body" | "bodySmall";
}

const TitleBlock: React.FC<Props> = ({
  title,
  subTitle,
  className,
  titleVariant = "title1",
  subtitleVariant = "body",
}) => {
  return (
    <div className={toClassName(styles.container, className)}>
      <Text variant={titleVariant} color="text">
        {title}
      </Text>
      {subTitle && (
        <Text variant={subtitleVariant} color="textSubtle">
          {subTitle}
        </Text>
      )}
    </div>
  );
};

export default TitleBlock;
